export default __webpack_public_path__ + "static/media/mini_ic_duplicate.25064773.svg";